import { TaskStatus } from '../../types/interfaces';
import { ObjectForSelection } from '../../types/interfaces/ObjectForSelection';
import { TaskStatusesWithClosingCodes } from '../../types/interfaces/TaskStatusesWithClosingCodes';
import IApiCalls from '../api/interfaces/apiCalls';

import BaseService from './BaseService';
import ServiceResult from './interfaces/ServiceResult';
import ITaskStatusesService from './interfaces/TaskStatusesService';

class TaskStatusesService
  extends BaseService<TaskStatus>
  implements ITaskStatusesService
{
  constructor(apiCalls: IApiCalls) {
    super(apiCalls, 'TaskStatuses');
  }

  getWithClosingCodes(
    id: number | undefined
  ): ServiceResult<TaskStatusesWithClosingCodes> {
    const apiCalls = this._apiCalls.beginApiCalls();
    if (!id) {
      return {
        result: apiCalls.ClosingCodes.getForSelection().then((x) => ({
          taskStatuses: undefined,
          closingCodes: x
        })),
        cancel: apiCalls.cancelAllCalls
      };
    }
    const resultPromise = Promise.all([
      apiCalls.TaskStatuses.get(id),
      apiCalls.ClosingCodes.getForSelection()
    ]).then(
      ([taskStatuses, closingCodes]): TaskStatusesWithClosingCodes => ({
        taskStatuses,
        closingCodes
      })
    );
    return { result: resultPromise, cancel: apiCalls.cancelAllCalls };
  }

  getForSelection(): ServiceResult<ObjectForSelection[] | undefined> {
    const apiCalls = this._apiCalls.beginApiCalls();
    return {
      result: apiCalls.TaskStatuses.getForSelection(),
      cancel: apiCalls.cancelAllCalls
    };
  }
}

export default TaskStatusesService;
